<template>
  <b-card
    id="roadmap-workflow-settings"
    class="roadmap-workflow-card"
  >
    <template #header>
      <div class="card-heading">
        <i class="fas fa-code-branch" />
        <h4>Règle de désynchronisation des run sheets</h4>
      </div>
    </template>

    <p class="description">
      Paramétrage technique réservé aux administrateurs développeurs. La règle
      est configurée indépendamment pour chaque société.
    </p>

    <b-form @submit.prevent="saveSettings">
      <b-form-group
        label="Société"
        label-for="roadmap-workflow-company"
      >
        <b-form-select
          id="roadmap-workflow-company"
          v-model="selectedCompanyId"
          :options="companyOptions"
          :disabled="loading || companies.length === 0"
          @change="loadSelectedCompanySettings"
        />
      </b-form-group>

      <b-form-group
        label="Colis synchronisés avec un prestataire"
        label-for="require-order-desynchronization-before-roadmap"
      >
        <b-form-checkbox
          id="require-order-desynchronization-before-roadmap"
          v-model="requireDesynchronization"
          switch
          :disabled="loading || !selectedCompanyId"
        >
          Exiger la désynchronisation avant l'ajout à une run sheet
        </b-form-checkbox>
        <small class="text-muted d-block mt-1">
          Si cette option est activée, un colis ayant une référence externe et
          une société de livraison associée doit être désynchronisé avant son
          ajout. Si elle est désactivée, le workflow actuel reste inchangé.
        </small>
      </b-form-group>

      <div class="actions">
        <b-button
          type="submit"
          variant="primary"
          :disabled="loading || !selectedCompanyId"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-2"
          />
          <i
            v-else
            class="fas fa-save mr-2"
          />
          Enregistrer la règle
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import axios from 'axios'
import {
  BButton,
  BCard,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'RoadmapDesynchronizationSettings',
  components: {
    BButton,
    BCard,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BSpinner,
  },
  data() {
    return {
      companies: [],
      selectedCompanyId: null,
      requireDesynchronization: false,
      loading: false,
    }
  },
  computed: {
    companyOptions() {
      return [
        { value: null, text: 'Sélectionner une société', disabled: true },
        ...this.companies.map(company => ({
          value: company.id,
          text: company.name || `Société #${company.id}`,
        })),
      ]
    },
  },
  created() {
    this.fetchCompanies()
  },
  methods: {
    loadSelectedCompanySettings() {
      const company = this.companies.find(item => item.id === this.selectedCompanyId)
      this.requireDesynchronization = Boolean(
        company && company.require_order_desynchronization_before_roadmap,
      )
    },
    async fetchCompanies() {
      this.loading = true
      try {
        const { data } = await axios.get('/api/companies/roadmap-desynchronization-settings/')
        this.companies = Array.isArray(data) ? data : (data.results || [])
        if (this.companies.length > 0) {
          this.selectedCompanyId = this.companies[0].id
          this.loadSelectedCompanySettings()
        }
      } catch (error) {
        this.$bvToast.toast('Impossible de charger les règles des run sheets', {
          title: 'Erreur',
          variant: 'danger',
        })
      } finally {
        this.loading = false
      }
    },
    async saveSettings() {
      if (!this.selectedCompanyId) return

      this.loading = true
      try {
        const { data } = await axios.patch(
          `/api/companies/roadmap-desynchronization-settings/${this.selectedCompanyId}/`,
          {
            require_order_desynchronization_before_roadmap: Boolean(
              this.requireDesynchronization,
            ),
          },
        )
        const index = this.companies.findIndex(company => company.id === data.id)
        if (index !== -1) this.$set(this.companies, index, data)
        this.loadSelectedCompanySettings()
        this.$bvToast.toast('Règle de création des run sheets enregistrée avec succès', {
          title: 'Succès',
          variant: 'success',
        })
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.detail || 'Impossible d\'enregistrer la règle des run sheets',
          { title: 'Erreur', variant: 'danger' },
        )
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.roadmap-workflow-card {
  margin-bottom: 2rem;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.08);
}

.card-heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.card-heading h4 {
  margin: 0;
  font-weight: 600;
}

.card-heading i {
  color: #7367f0;
}

.description {
  margin-bottom: 1.5rem;
  color: #6e6b7b;
}

.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
